module.exports = __webpack_public_path__ + "img/minimize_pressed.52783328.svg";